import { Row } from "@components/Flex";
import { Caption } from "@components/Typography";
import { useProjectedChart } from "@hooks";
import { Translations, i18n } from "@i18n";
import { formatCurrency } from "@utils";
import { useStyles } from "./styles";
import { CircleProps } from "./types";

export const InvestedReturns = () => {
  const styles = useStyles();

  const { investedColor, returnedColor, investedAmount, returnedAmount, showInvestmentAmounts } =
    useProjectedChart();

  return (
    <Row style={styles.container}>
      <Row>
        <Circle color={investedColor} />
        <Caption style={styles.text}>
          {i18n.t(Translations.GoalDepositRouteInvested, {
            amount: showInvestmentAmounts ? `: ${formatCurrency(investedAmount)}` : "",
          })}
        </Caption>
      </Row>
      <Row>
        <Circle color={returnedColor} />
        <Caption style={styles.text}>
          {i18n.t(Translations.GoalDepositRouteReturns, {
            amount: showInvestmentAmounts ? `: ${formatCurrency(returnedAmount)}` : "",
          })}
        </Caption>
      </Row>
    </Row>
  );
};

const Circle = ({ color }: CircleProps) => {
  const styles = useStyles();

  return <div style={{ ...styles.circle, backgroundColor: color }} />;
};
